/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import cross from '../../images/CloseSquare.png';
import CardWorkSpace from './workspacecard';
import Urls from '../../utils/urls';
import ApiRequests from '../../utils/RequestBody';

import { prefixPath } from '../../utils/helpers';
import Paginate from '../pagination/paginate';
import apiBackendInstance from '../../utils/axios';

export interface workspaceDataInterface {
    id: number | string,
    name: string,
    networks: number|string,
    nodes: number,
    members: number,
    createdAt: number|string,
    endpoints: number|string,
    success?: boolean
}

const WorkspaceBody = ({ theme }:{theme:string}) => {
  const [refresh, setRefresh] = useState(true);
  const [workspaceData, setWorkspaceData] = useState<workspaceDataInterface[]>([]);
  const [renderPagination, setRenderPagination] = useState(false);
  const [workspaceDataLength, setWorkspaceDataLength] = useState(0);
  const loaderUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);
  const imgSubPath = window.location.origin;
  const addImg = imgSubPath + prefixPath(`/img/${theme}/Add Workspace.png`);
  const addIconImg = imgSubPath + prefixPath(`/img/${theme}/add-icon.png`);
  const passwordRegex = /^[a-zA-Z0-9-]+$/;

  async function getPage(offset:number, limit:number):Promise<boolean> {
    try {
      const response = await apiBackendInstance.get(Urls.getAllWorkspace(offset, limit), {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      if (response && response.data && response.data.data && response.data.data.workspaceDetailsList) {
        setWorkspaceData(response.data.data.workspaceDetailsList);
        return true;
      }
    } catch (error) {
      console.log(error);
    }
    return false;
  }

  const getWorkSpaceList = () => {
    showLoader();
    apiBackendInstance.get(Urls.getAllWorkspace(0, 7), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data && response.data.data.workspaceDetailsList) {
        const workspaceList = response.data.data.workspaceDetailsList;
        const workspaceListCount = Number(response.data.data.totalWorkspaceListCount);
        if (workspaceListCount > 7) {
          setWorkspaceDataLength(workspaceListCount);
          setRenderPagination(true);
        }
        setWorkspaceData(workspaceList);
      }
      hideLoader();
    }).catch(() => {
      setWorkspaceData([]);
      setRenderPagination(false);
      hideLoader();
    });
  };
  useEffect(() => {
    getWorkSpaceList();
  }, [refresh]);

  // add workspace
  const addWorkspace = (workspacename: string, description: string): void => {
    const addbtn = document.getElementById('addWorkspace');
    if (addbtn) {
      addbtn.style.display = 'none';
    }
    showLoader();
    apiBackendInstance.post(Urls.createWorkspace(),
      {
        data: ApiRequests.createWorkspaceBody(
          workspacename, description,
        ),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
      const { data } = response;
      if ((data.Success || data.success) && data.data && data.data.success) {
        showMessage(1, 'successworkMsg');
        setTimeout(() => {
          getWorkSpaceList();
          hideAddWorkspaceModal();
        }, 2000);
      }
      setRefresh(!refresh);
      hideLoader();
    }).catch((err) => {
      console.error(err);
      showMessage(0, 'errorworkMsg');
      setRefresh(!refresh);
      hideLoader();
    });
  };
  const showAddWorkspaceModal = () => {
    hideAddMessage();
    const addbtn = document.getElementById('addWorkspace');
    if (addbtn) {
      addbtn.style.display = 'block';
    }
    const modal = document.getElementById('createWorkspace');
    if (modal) {
      modal.style.display = 'block';
    }
  };
  const hideAddWorkspaceModal = () => {
    const modal = document.getElementById('createWorkspace');
    if (modal) {
      modal.style.display = 'none';
    }
  };
  // delete workspace
  const confirmDeleteWorkSpace = () => {
    const workIdTag = document.getElementById('workId');
    const deleteBtn = document.getElementById('deleteNetworkBtn2');
    showLoader();
    let workId = '';
    if (workIdTag && workIdTag.textContent) {
      workId = workIdTag.textContent;
    }
    if (deleteBtn) {
      deleteBtn.style.display = 'none';
    }
    apiBackendInstance.delete(Urls.deleteWorkspaceById(workId), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data.data) {
        if (response.data.data) {
          if (!response.data.data.success) {
            showFailMessage('show', response.data.data.msg);
          }
          if (response.data.data.success) {
            showSuccessMessage('show');
            setTimeout(() => {
              getWorkSpaceList();
              hideDeleteModal();
            }, 2000);
          }
        }
      }
      hideLoader();
    }).catch((err) => {
      showFailMessage('show', 'error deleting workspace');
      console.error(err);
      hideLoader();
    });
  };

  const hideDeleteModal = () => {
    const modal: HTMLElement | null = document.getElementById('deleteWorkSpace');
    if (modal) {
      modal.style.display = 'none';
    }
  };
  // edit workspace
  const editWorkspaceApi = (workspacename: string, description: string, workspaceId:string): void => {
    const editbtn = document.getElementById('editworkBtn');
    if (editbtn) {
      editbtn.style.display = 'none';
    }
    showLoader();
    apiBackendInstance.put(Urls.editWorkspace(workspaceId),
      {
        action: 'update-name',
        actionData: {
          name: workspacename,
        },
      }, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }).then((response) => {
      const { data } = response;
      if ((data.Success || data.success) && data.data) {
        showMessage(1, 'successMsg');
        setTimeout(() => { window.location.reload(); }, 2000);
      }
      hideLoader();
    }).catch((err) => {
      showMessage(0, 'errorMsg');
      console.error(err);
      setRefresh(!refresh);
      hideLoader();
    });
  };

  const hideEditWorkspaceModal = () => {
    const modal: HTMLElement | null = document.getElementById('editWorkSpace');
    if (modal) {
      modal.style.display = 'none';
    }
  };
  const showMessage = (option:number, tagId: string) => {
    if (option === 1) {
      const ptag = document.getElementById(tagId);
      if (ptag) {
        ptag.style.display = 'block';
      }
    } else {
      const ptag = document.getElementById(tagId);
      if (ptag) {
        ptag.style.display = 'block';
      }
    }
  };
  const showSuccessMessage = (option:string) => {
    const ptag1 = document.getElementById('successDeleteMsg');
    if (ptag1) {
      if (option === 'show') {
        ptag1.style.display = 'block';
      } else {
        ptag1.style.display = 'none';
      }
    }
  };
  const showFailMessage = (option:string, msg:string) => {
    const ptag1 = document.getElementById('deleteMsg');
    if (ptag1) {
      if (option === 'show') {
        ptag1.style.display = 'block';
        ptag1.innerHTML = msg;
      } else {
        ptag1.style.display = 'none';
      }
    }
  };
  const hideMessage = () => {
    const ptag1 = document.getElementById('successMsg');
    if (ptag1) {
      ptag1.style.display = 'none';
    }
    const ptag = document.getElementById('errorMsg');
    if (ptag) {
      ptag.style.display = 'none';
    }
  };
  const hideAddMessage = () => {
    const ptag1 = document.getElementById('successworkMsg');
    if (ptag1) {
      ptag1.style.display = 'none';
    }
    const ptag = document.getElementById('errorworkMsg');
    if (ptag) {
      ptag.style.display = 'none';
    }
  };
  function deleteWorkspace(id: string|number, networkCount:number, endpointCount:number) {
    showSuccessMessage('hide');
    showFailMessage('hide', '');
    const workIdTag = document.getElementById('workId');
    if (workIdTag) {
      workIdTag.innerHTML = id.toString();
    }
    const modal: HTMLElement | null = document.getElementById('deleteWorkSpace');
    const heading = document.getElementById('modalHeading');
    const deleteBtn = document.getElementById('deleteNetworkBtn2');
    if (networkCount !== 0 || endpointCount !== 0) {
      if (heading) {
        heading.innerHTML = 'Status';
        if (deleteBtn) {
          deleteBtn.style.display = 'none';
        }
      }
      showFailMessage('show', 'Cannot delete workspace having RPC endpoint or network');
    }
    if (networkCount === 0 && endpointCount === 0) {
      if (heading) {
        heading.innerHTML = 'Are you sure you want to delete workspace?';
      }
      if (deleteBtn) {
        deleteBtn.style.display = 'block';
      }
    }
    if (modal) {
      modal.style.display = 'block';
    }
  }

  const [editWorkspaceModalData, setEditWorkspaceModalData] = useState({
    name: '',
    Description: '',
    id: '',
    Error: '',
  });
  function editWorkspace(id:string|number, name:string) {
    hideMessage();
    const editbtn = document.getElementById('editworkBtn');
    if (editbtn) {
      editbtn.style.display = 'block';
    }
    setEditWorkspaceModalData({
      ...editWorkspaceModalData,
      name,
      id: id as string,
      Description: '',

    });
    const modal: HTMLElement | null = document.getElementById('editWorkSpace');
    if (modal) {
      modal.style.display = 'block';
    }
  }

  const [createWorkspaceModalData, setWorkspaceModalData] = useState({
    name: '',
    Description: '',
  });

  const [inable, setInable] = useState(false);
  const setDisable = () => {
    if (createWorkspaceModalData.name && createWorkspaceModalData.Description) {
      const name = validateAlphaNumeric(createWorkspaceModalData.name);
      const desc = validateAlphaNumericDesc(createWorkspaceModalData.Description);
      if (!name || !desc) {
        setInable(false);
        return;
      }
      if (createWorkspaceModalData.name.trim().length === 0 || createWorkspaceModalData.Description.trim().length === 0) {
        setInable(false);
        return;
      }
      setInable(true);
    } else {
      setInable(false);
    }
  };
  const showLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'block';
  };
  const hideLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'none';
  };

  const [enable, setValidation] = useState(true);
  const validateInput = (e: any) => {
    if (e.length >= 100) {
      setValidation(false);
      return false;
    }
    setValidation(true);
    return true;
  };

  const [enableDesc, setDescription] = useState(true);
  const validateDescription = (e: any) => {
    if (e.length >= 25) {
      setDescription(false);
      return false;
    }
    setDescription(true);
    return true;
  };

  const [enableAlphanumeric, setAlpha] = useState(true);
  const validateAlphaNumeric = (e: any) => {
    if (!passwordRegex.test(e) && e) {
      setAlpha(false);
      return false;
    }
    setAlpha(true);
    validateInput(e);
    return true;
  };

  const [enableAlphanumericDesc, setAlphaDesc] = useState(true);
  const validateAlphaNumericDesc = (e: any) => {
    if (!passwordRegex.test(e) && e) {
      setAlphaDesc(false);
      return false;
    }
    setAlphaDesc(true);
    validateDescription(e);
    return true;
  };

  const [enableEdit, setEdit] = useState(false);
  const [enableEditValidate, setEditValidate] = useState(true);
  const validateEdit = (e: any) => {
    if (passwordRegex.test(e) && e) {
      validateInput(e);
      setEditValidate(true);
      if (e.length < 1) {
        setEdit(false);
      } else {
        setEdit(true);
      }
    } else {
      setEdit(false);
      setEditValidate(false);
      validateInput(e);
    }
  };

  return (
        <section className="px-5 col-12 workspace">
            <div className="cardBlack">
              <div className="row mt-4 mb-4">
                <div className="col-lg-6 pt-2 col-xl-6 col-sm-12 col-xs-12">
                  <p className="fs-6">
                    <span className="fw-bold">Workspaces</span>
                      {' '}
                    <span className="span-color mx-1"> Manage your workspaces</span>
                  </p>
                </div>
                <div className="col-lg-6 col-xl-6 col-sm-12 col-xs-12 text-end button-add">
                  <button type="button" className="btn comingSoon" onClick={() => { showAddWorkspaceModal(); }}>
                    <img className="mx-2" src={addImg} alt="" />
                    Add Workspace
                  </button>
                </div>
                {/* add workspace modal */}
                <div id="createWorkspace" className="workModal text-black">
                  <div className="workModalContent">
                    <form>
                      <div className="mb-3  col-11 mx-auto">
                        <div className="modal-header" style={{ paddingLeft: '0px' }}>
                          <h1
                            className="modal-title"
                            id="createWork"
                            style={{ fontSize: 30, color: 'black' }}
                          >
                            Create Workspace
                          </h1>
                          <div>
                            <span onClick={() => { hideAddWorkspaceModal(); }} className="closeWork">&times;</span>
                          </div>
                        </div>
                        <label htmlFor="" className="mb-1 mt-2 col-form-label label-1">
                          New Workspace Name
                          <span className="text-danger mx-1">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control text-black"
                          maxLength={100}
                          id=""
                          required
                          placeholder="Workspace Name"
                          onChange={(val) => {
                            validateAlphaNumeric(val.target.value);
                            createWorkspaceModalData.name = val.target.value;
                            setWorkspaceModalData(createWorkspaceModalData);
                            setDisable();
                          }}
                        />
                        {!enable && (
                          <p style={{ color: 'red' }}>
                          Workspace Name should have less than 100 character
                          </p>
                        )}
                        {!enableAlphanumeric && (
                          <p style={{ color: 'red' }}>
                          only alphanumeric allowed
                          </p>
                        )}
                      </div>
                      <div className="mb-3 col-11 mx-auto short-description">
                      <label htmlFor="" className="mb-1 col-form-label label-1">
                        Short Description
                        <span className="text-danger mx-1">*</span>
                      </label>
                      <textarea
                        className="form-control text-black"
                        maxLength={25}
                        id=""
                        placeholder="Type Short description"
                        onChange={(val) => {
                          validateAlphaNumericDesc(val.target.value);
                          createWorkspaceModalData.Description = val.target.value;
                          setWorkspaceModalData(createWorkspaceModalData);
                          setDisable();
                        }}
                      />
                      {!enableDesc && (
                          <p style={{ color: 'red' }}>
                          Description should have less than 25 character
                          </p>
                      )}
                      {!enableAlphanumericDesc && (
                          <p style={{ color: 'red' }}>
                          only alphanumeric allowed
                          </p>
                      )}
                      </div>
                    </form>
                    <div id="successworkMsg" className="alert alert-success mt-4 mb-3" style={{ display: 'none' }} role="alert">Workspace Created</div>
                  <div id="errorworkMsg" className="alert alert-danger mt-4 mb-3" style={{ display: 'none' }} role="alert">Failed Creating Workspace</div>
                    <div className="col-11 mb-4 mt-3 mx-auto text-center">
                      <button
                        disabled={!inable}
                        type="button"
                        style={{ margin: 'auto' }}
                        className="btn comingSoon"
                        id="addWorkspace"
                        onClick={() => {
                          addWorkspace(createWorkspaceModalData.name, createWorkspaceModalData.Description);
                        }}
                      >
                        Create Workspace
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className="modal fade"
                  id="createWorkspacefade"
                  tabIndex={-1}
                  style={{ display: 'none' }}
                >
                <div className="modal-dialog modal-dialog-centered" id="createWorkspace">
                  <div className=" modal-content">
                    <div className="modal-header">
                      <h1
                        className="modal-title"
                        id="createWork"
                        style={{ fontSize: 30, color: 'black' }}
                      >
                        Create Workspace
                      </h1>
                      <img
                        src={cross}
                        alt=""
                        className="cursor"
                         onClick={() => { hideAddWorkspaceModal(); }}
                      />
                    </div>
                    <div className="modal-body text-left">
                      <form>
                        <div className="mb-3 col-11 mx-auto">
                            <label htmlFor="" className="mb-1 col-form-label label-1">
                               New workspace name
                            </label>
                            <input
                              type="text"
                              className="form-control text-black"
                              id=""
                              placeholder="Workspace Name"
                              onChange={(val) => {
                                createWorkspaceModalData.name = val.target.value;
                                setWorkspaceModalData(createWorkspaceModalData);
                                setDisable();
                              }}
                            />
                        </div>
                        <div className="mb-3 col-11 mx-auto short-description ">
                          <label htmlFor="" className="mb-1">
                            Short Description
                          </label>
                          <textarea
                            className="form-control text-black required"
                            id=""
                            placeholder="Type Short description"
                            onChange={(val) => {
                              createWorkspaceModalData.Description = val.target.value;
                              setWorkspaceModalData(createWorkspaceModalData);
                              setDisable();
                            }}
                          />
                        </div>
                      </form>
                      <div className="col-11 mb-4 mt-3 mx-auto text-center">
                        <button
                          disabled={!inable}
                          type="button"
                          style={{ }}
                          className="btn comingSoon col-12"
                          id="addWorkspace"
                          onClick={() => {
                            addWorkspace(createWorkspaceModalData.name, createWorkspaceModalData.Description);
                          }}
                        >
                        Create
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                  <div className="mt-2 row">
                    {/* add workspace card starts here */}
                    <div className="col-lg-4 col-xl-3 col-md-6 col-sm-12 mt-5 cursor mg-auto">
                      <div
                          className="mt-1 text-center"
                          onClick={() => { showAddWorkspaceModal(); }}
                      >
                        <div className="workSpaceCard">
                          <div className="card-body text-center add-workspace py-4">
                            <div className="mt-2  mx-auto text-center">
                                <img className="mt-2 mb-3" src={addIconImg} alt="" />
                                <h6 className="mt-2 activeTextColor">New Workspace</h6>
                              <p>
                                Space where you can Deploy your Nodes and APIs for your Use Cases.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      workspaceData.map((o, idx) => (
                        <CardWorkSpace
                          total={workspaceData.length}
                          cardnumber={idx}
                          key={idx.toString()}
                          id={o.id}
                          name={o.name}
                          networks={parseInt(o.networks.toString(), 10)}
                          nodes={o.nodes}
                          members={o.members}
                          endpoints={parseInt(o.endpoints.toString(), 10)}
                          createdAt={o.createdAt}
                          deleteWorkspace={deleteWorkspace}
                          editWorkspace={editWorkspace}
                        />
                      ))
                    }
                  </div>
                  <div
                    id="spinnerDiv"
                    className="text-center mx-5 p-3 col-11 "
                    style={{ display: 'none' }}
                  >
                    <img className="" style={{ margin: 'auto' }} src={loaderUrl} alt="spinnner" />
                  </div>
              </div>
            </div>
            {/* delete worksapce */}
            <div id="deleteWorkSpace" className="workModal text-black">
              <div className="workModalContent">
                {/* <span onClick={() => { hideDeleteModal(); }} className="closeWork">&times;</span> */}
                  <h6 id="modalHeading" className="modalHeading mb-4 text-center">
                    Are you sure you want to delete workspace?
                  </h6>
                <p id="workId" style={{ display: 'none' }}>workId</p>
                <div id="successDeleteMsg" className="alert alert-success mt-4 mb-3 text-center" style={{ display: 'none' }} role="alert">Workspace Deleted</div>
                <div id="deleteMsg" className="alert alert-danger mt-4 mb-3 text-center" style={{ display: 'none' }} role="alert">Error deleting workspace</div>
                <div className="mt-4">
                  <div className="d-flex justify-content-center">
                    <button type="button" className="btn btn-secondary" onClick={() => { hideDeleteModal(); }}>cancel</button>
                  <div />
                  <div>
                    <button type="button" id="deleteNetworkBtn2" className="btn comingSoon ms-2" onClick={() => { confirmDeleteWorkSpace(); }}>Yes</button>
                  </div>
                  </div>
                </div>
              </div>
            </div>
            {/* edit worksapce */}
            <div id="editWorkSpace" className="workModal text-black text-center">
              <div className="workModalContent">
                  <form>
                    <div className="mb-3 col-11 mx-auto">
                      <div className="modal-header" style={{ paddingLeft: '0px' }}>
                        <h6
                          className="modal-title"
                          id="modalHeading"
                          style={{ fontSize: 20, color: 'black' }}
                        >
                          Edit Workspace
                        </h6>
                        <div>
                          <span onClick={() => { hideEditWorkspaceModal(); }} className="closeWork">&times;</span>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control text-black required"
                        maxLength={100}
                        id=""
                        required
                        placeholder="Workspace Name"
                        defaultValue={editWorkspaceModalData.name}
                        onChange={(val) => {
                          validateEdit(val.target.value);
                          setEditWorkspaceModalData({ ...editWorkspaceModalData, name: val.target.value });
                          setDisable();
                        }}
                      />
                      {!enable && (
                          <p style={{ color: 'red' }}>
                          Workspace Name should have less than 100 character
                          </p>
                      )}
                      {!enableEditValidate && (
                          <p style={{ color: 'red' }}>
                          only alphanumeric allowed
                          </p>
                      )}
                    </div>
                  </form>
                  <button
                    type="button"
                    disabled={!enableEdit}
                    id="editworkBtn"
                    style={{ margin: 'auto' }}
                    className="btn comingSoon"
                    onClick={() => {
                      editWorkspaceApi(editWorkspaceModalData.name,
                        editWorkspaceModalData.Description, editWorkspaceModalData.id);
                    }}
                  >
                    Update
                  </button>
                  <div id="successMsg" className="alert alert-success mt-4 mb-3" style={{ display: 'none' }} role="alert">Workspace Updated</div>
                  <div id="errorMsg" className="alert alert-danger mt-4 mb-3" style={{ display: 'none' }} role="alert">Failed updating Workspace</div>
              </div>
            </div>
            <Paginate totalItems={workspaceDataLength} itemsPerPage={7} renderPagination={renderPagination} getPage={getPage} pageLimit={7} />
        </section>

  );
};

export default WorkspaceBody;